const CurrencyTypes = {
  GET_CURRENCY_LIST_REQUEST: 'GET_CURRENCY_LIST_REQUEST',
  GET_CURRENCY_LIST_SUCCESS: 'GET_CURRENCY_LIST_SUCCESS',
  GET_CURRENCY_LIST_ERROR: 'GET_CURRENCY_LIST_ERROR',

  GET_ALL_CURRENCY_LIST_REQUEST: 'GET_ALL_CURRENCY_LIST_REQUEST',
  GET_ALL_CURRENCY_LIST_SUCCESS: 'GET_ALL_CURRENCY_LIST_SUCCESS',
  GET_ALL_CURRENCY_LIST_ERROR: 'GET_ALL_CURRENCY_LIST_ERROR',

  ADD_CURRENCY_REQUEST: 'ADD_CURRENCY_REQUEST',
  ADD_CURRENCY_SUCCESS: 'ADD_CURRENCY_SUCCESS',
  ADD_CURRENCY_ERROR: 'ADD_CURRENCY_ERROR',

  GET_CURRENCY_ITEM_REQUEST: 'GET_CURRENCY_ITEM_REQUEST',
  GET_CURRENCY_ITEM_SUCCESS: 'GET_CURRENCY_ITEM_SUCCESS',
  GET_CURRENCY_ITEM_ERROR: 'GET_CURRENCY_ITEM_ERROR',

  UPDATE_CURRENCY_REQUEST: 'UPDATE_CURRENCY_REQUEST',
  UPDATE_CURRENCY_SUCCESS: 'UPDATE_CURRENCY_SUCCESS',
  UPDATE_CURRENCY_ERROR: 'UPDATE_CURRENCY_ERROR',

  DELETE_CURRENCY_REQUEST: 'DELETE_CURRENCY_REQUEST',
  DELETE_CURRENCY_SUCCESS: 'DELETE_CURRENCY_SUCCESS',
  DELETE_CURRENCY_ERROR: 'DELETE_CURRENCY_ERROR',

  GET_CURRENCY_ACTIVE_REQUEST: 'GET_CURRENCY_ACTIVE_REQUEST',
  GET_CURRENCY_ACTIVE_SUCCESS: 'GET_CURRENCY_ACTIVE_SUCCESS',
  GET_CURRENCY_ACTIVE_ERROR: 'GET_CURRENCY_ACTIVE_ERROR',

  UPDATE_CURRENCY_QUERY_PARAMS: 'UPDATE_CURRENCY_QUERY_PARAMS'
};
export default CurrencyTypes;
